<template>
  <v-card class="pa-0 pa-md-6" elevation="0">
    <v-card-text class="py-5" ref="content">
      <div class="d-flex justify-space-between align-center mb-5">
        <h3>Quick view</h3>
        <v-btn @click="$emit('close')" icon color="red" class="ml-auto">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-row class="mb-6" dense>
        <v-col cols="9">
          <v-responsive :aspect-ratio="1">
            <v-card class="fill-height position-relative" outlined>
              <ProxyImage :src="item.primary_picture"/>
            </v-card>
          </v-responsive>
        </v-col>
        <v-col cols="3">
          <v-responsive :aspect-ratio="1" class="mb-2">
            <v-card
              @click="$router.push(`/${$store.state.merchant.slug}/item/${item.slug}`)"
              class="fill-height d-flex justify-center align-center"
              outlined
            >
              <v-icon>mdi-arrow-right</v-icon>
            </v-card>
          </v-responsive>
          <v-responsive :aspect-ratio="1" class="mb-2">
            <v-card class="fill-height d-flex flex-column justify-center align-center" outlined>
              <v-icon color="red">mdi-heart</v-icon>
              <small class="mt-1">{{ item.likes }} likes</small>
            </v-card>
          </v-responsive>
          <v-responsive :aspect-ratio="1">
            <v-card class="fill-height d-flex flex-column justify-center align-center" outlined>
              <v-icon color="green">mdi-cart-check</v-icon>
              <small class="mt-1">{{ item.buys }} buys</small>
            </v-card>
          </v-responsive>
        </v-col>
      </v-row>

      <div class="d-flex flex-column align-start fill-width">
        <div>{{ item.name }}</div>
        <div class="d-flex align-center justify-space-between fill-width">
          <div class="d-flex align-center mr-3">
            <v-rating :value="itemRating" background-color="orange lighten-3" color="orange" dense readonly size="20"/>
            <span class="text-small ml-2" v-if="item.total_ratings">({{ item.total_ratings }} review(s))</span>
          </div>
          <v-chip color="red" dark v-if="credit" x-small>Credit</v-chip>
          <v-chip color="blue" dark v-else x-small>Outright</v-chip>
        </div>
      </div>

      <v-divider class="my-4"></v-divider>

      <div class="d-flex align-center justify-space-between mt-3">
        <div v-if="selected.monthly_amount_estimate || selected.monthly_amount">
          <v-chip class="percent-off px-4 mb-2" color="red" outlined small v-if="discount">{{ discount.percentage }}%
            off
            <span v-if="discount.end">, ends {{ discount.end | timeago }}</span>
          </v-chip>
          <div class="title font-weight-bold text--black">
            {{ (selected.monthly_amount_estimate || selected.monthly_amount) | currency }} / mo
          </div>
          <div class="text-strikethrough mt-1 d-flex" v-if="discount">
            {{ (item.credit_price || item.price) / item.no_of_months | currency }}
          </div>
          <div class="text-body-1 mt-1">
            {{ selected.no_of_months }} installment(s)
          </div>
        </div>
        <div v-else>
          <v-chip class="percent-off px-4 mb-2" color="red" outlined small v-if="discount">{{ discount.percentage }}%
            off
            <span v-if="discount.end">, ends {{ discount.end | timeago }}</span>
          </v-chip>
          <div class="title font-weight-medium text--secondary">
            {{ selected.upfront_amount | currency }} outright
          </div>
          <div class="text-strikethrough mt-1 d-flex" v-if="discount">{{ item.price | currency }}</div>
        </div>
        <v-switch :disabled="!credit" class="ma-0" dense hide-details inset v-model="buy_on_credit"></v-switch>
      </div>

      <v-divider class="my-4"></v-divider>

      <template v-if="sizes.length">
        <div class="d-inline-flex align-center">
          <v-radio-group class="ma-0" hide-details label="Size" row v-if="sizes && sizes.length"
                         v-model="variations.size">
            <v-radio :key="size" :label="size" :value="size" v-for="size in sizes"></v-radio>
          </v-radio-group>
        </div>
        <v-divider class="my-4"></v-divider>
      </template>

      <template v-if="$store.state.merchant.partnership === 1 || !buy_on_credit">
        <div class="d-flex mt-6">
          <v-text-field :value="quantity" dense hide-details outlined readonly style="max-width: 150px">
            <v-icon @click="decrementQuantity()" color="red" slot="prepend">mdi-minus</v-icon>
            <v-icon @click="incrementQuantity()" color="green" slot="append-outer">mdi-plus</v-icon>
          </v-text-field>
          <v-btn @click="addToCart()" class="flex-grow-1 ml-3" color="primary" elevation="0">
            <v-icon class="mr-2">mdi-cart-plus</v-icon>
            Add to cart
          </v-btn>
        </div>
      </template>

      <div v-else>
        <div class="text-small mb-3">Choose a payment plan below to add this item to your cart</div>
        <ItemPlans :plans="plans" :show-title="false" @select="handlePlanChange($event, true)"/>
      </div>

      <v-snackbar :color="toast.color || ''" absolute bottom v-model="toast.visible">
        {{ toast.message }}
      </v-snackbar>
    </v-card-text>
  </v-card>
</template>
<script>
import item from "../../mixins/item";
import ItemPlans from "../item/ItemPlans";
import ProxyImage from "../ProxyImage";

export default {
  name: 'QuickAddToCart',
  components: { ProxyImage, ItemPlans },
  mixins: [item],
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  created() {
    this.item = this.value;
    this.buy_on_credit = this.item.sell_on_credit === 1;
    this.selectPlan(this.buy_on_credit);
  },
}
</script>
